import { OnboardingPayloadData } from '@/contexts/onboardingContext';

export interface PrimarySubstanceFormValues extends OnboardingPayloadData {
  drugCategory: string;
  primarySubstance: string;
  programScope: Needs;
  treatmentPreference?: string;
}

export enum Needs {
  MentalHealth = 'mental_health',
  SubstanceUse = 'substance_use'
}
